export default {
  redeemCode: {
    title: 'Tebus Kod',
    description: 'Masukkan kod tebusan anda di bawah untuk menuntut ganjaran anda.',
    enterTip: 'Masukkan kod tebus anda untuk menuntut ganjaran',
    label: 'Kod Tebusan',
    placeholder: 'Masukkan kod tebusan',
    submit: 'Tebus',
    redeemBtn: 'TEBUS',
    submitting: 'Menebus...',
    success: 'Kod berjaya ditebus!',
    redeemSuccess: 'Kod berjaya ditebus!',
    failed: 'Gagal menebus kod, sila cuba lagi.',
    redeemFailed: 'Gagal menebus kod, sila cuba lagi.'
  }
};
